import type { ReactElement } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { policySubPath } from '@/lib/policyPaths';
import { CATALOG_TIERS } from '../constants/builtin-catalog';

/**
 * KIR-2691: the "Built-in Detection Catalog" row on the Extension Security
 * policy. Mirrors the "Edit Custom Rules" affordance but opens a read-only
 * full page (scope derived from the route) instead of a modal.
 */
export function BuiltInCatalogLink(): ReactElement {
  const { organizationId } = useParams<{ organizationId?: string }>();

  const catalogPath = policySubPath(
    organizationId,
    'extension-security-catalog'
  );

  const ruleCount = CATALOG_TIERS.reduce(
    (total, tier) => total + tier.rules.length,
    0
  );

  return (
    <div className="policy-setting-group">
      <div className="policy-setting-label">
        <Label>Built-in Detection Catalog</Label>
      </div>
      <p className="text-sm text-muted-foreground">
        Kirin&apos;s built-in rules, evaluated automatically against extension
        manifests. View the full read-only catalog and how each rule is scored.
      </p>
      <Button asChild variant="outline" className="mt-2">
        <Link to={catalogPath}>View Built-in Catalog ({ruleCount})</Link>
      </Button>
    </div>
  );
}
